function BootstrapService($window) {
    this._data = $window.bootstrapData || {};

    // A map of objects which are bootstrapped
    this.bootstrapped = {
        //Config: 'ConfigRequest',
        Settings: '/Settings',
        PageModel: '/Settings/PageModel'
        //Shopper: 'ShopperDetailsRequest',
        //ShopperPreferences: 'ShopperPreferencesRequest',
        //Categories: 'ListCategoriesRequest'//,
        //Trolley: 'TrolleyRequest',
        //DeliveryInfo: 'GetDeliveryInfoRequest',
        //Orders: 'OrdersRequest',
        //SpecialsGroups: 'SpecialsGroupListForShopRequest',
        //SpecialsCategories: 'ListCategoriesForSpecialsRequest',
        //RecipeCategories: 'ListRecipeCategoriesRequest',
        //SavedLists: 'ListSavedListsRequest',
        //SuggestedLists: 'ListSuggestedListsRequest',
        //SearchPhraseActions: 'ListSearchPhraseActionsRequest'
    };

}

BootstrapService.prototype.getBootstrappedData = function (key) {
    return this._data[key];
};

BootstrapService.prototype.isBootstrapped = function (key) {
    return key in this._data && !!this._data[key];
};

BootstrapService.prototype.getSettingValue = function(group, nameKey) {
    if (!this._data) {
      return;
    }

    const settingsData = this.getBootstrappedData('/Settings');
    const setting = settingsData.find(s => s.Group === group && s.Name === nameKey);
    return setting ? setting.Value : undefined;
}

BootstrapService.prototype.getPageModelData = function (key) {
    const pageModel = this._data[this.bootstrapped.PageModel];

    return pageModel && pageModel[key]
        ? pageModel[key]
        : null;
};

module.exports = BootstrapService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/bootstrap/bootstrap-service.js
 **/